export const Step = {
  LOGIN: 'LOGIN',
  PASSWORD_LOGIN: 'PASSWORD_LOGIN',
  VERIFY_WITH_PASSWORD: 'VERIFY_WITH_PASSWORD',
  VERIFY_WITHOUT_PASSWORD: 'VERIFY_WITHOUT_PASSWORD',
  SIGN_UP_VERIFY: 'SIGN_UP_VERIFY',
  COMPLETE_PROFILE: 'COMPLETE_PROFILE',
  SIGN_UP: 'SIGN_UP',
  VERIFIED: 'VERIFIED',
  EXPIRED: 'EXPIRED',
  LOGGED_IN: 'LOGGED_IN',
  SIGN_UP_SOCIAL: 'SIGN_UP_SOCIAL',
  SOCIAL_ONLY: 'SOCIAL_ONLY'
};

export const StepRoute = {
  LOGIN: 'login',
  PASSWORD_LOGIN: 'login',
  VERIFY_WITH_PASSWORD: 'verifyRequired',
  VERIFY_WITHOUT_PASSWORD: 'completeRequired',
  SOCIAL_ONLY: 'socialOnly',
  SIGN_UP_VERIFY: 'verifyRequired',
  COMPLETE_PROFILE: 'signup',
  SIGN_UP: 'signup',
  VERIFIED: 'verifySuccess',
  EXPIRED: 'resetRequired',
};

export function navigate(router, { from, to, email }) {
  const fromRoute = StepRoute[from];
  const route = StepRoute[to];

  if (route) {
    router.push({
      name: route,
      params: email ? { email } : {},
      query: email ? { email, from: fromRoute } : {},
    });
  }
}
